var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46.5px",
    height: "52.5px",
    viewBox: "0 0 31 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(0.000077, 0.000026)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5506205,17.0381529 L27.5506205,18.4187369 L27.5506205,30.7349047 L27.5506205,31.8308901 L26.4546351,31.8308901 L4.01835767,31.8308901 L2.92237227,31.8308901 L2.92237227,30.7349047 L2.92237227,15.8782989 L2.92237227,14.7823135 L7.87678832,9.98348133 L12.8309489,5.18490469 L12.8309489,4.08891929 L12.8309489,2.21961272 L12.8309489,1.12362732 L12.0435767,1.88570761 L12.0435767,1.88570761 L6.41547445,7.33242294 L0.787372263,12.7793938 C0.354343066,13.1986274 -8.8817842e-16,14.0347953 -8.8817842e-16,14.6374595 L-8.8817842e-16,33.6575325 C-8.8817842e-16,34.2601967 0.493065694,34.7535179 1.0959854,34.7535179 L29.3772628,34.7535179 C29.979927,34.7535179 30.4732482,34.2601967 30.4732482,33.6575325 L30.4732482,17.0215471",
    id: "Fill-1",
    fill: "#68C9D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5529343,12.2890876 L17.5529343,5.56346715 L24.5723504,12.2890876 L17.5529343,12.2890876 Z M15.1782993,-1.42108547e-14 L15.1782993,14.6637227 L30.4730438,14.6637227 L30.4730438,14.6540146 L15.1782993,-1.42108547e-14 Z",
    id: "Fill-4",
    fill: "#BFD62F"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#68C9D6",
    points: "5.81375548 28.9107409 24.6419672 28.9107409 24.6419672 26.5361059 5.81375548 26.5361059"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#68C9D6",
    points: "5.8135 24.1617263 20.0607993 24.1617263 20.0607993 21.7870913 5.8135 21.7870913"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#68C9D6",
    points: "5.94558029 19.4127117 13.06923 19.4127117 13.06923 17.0380767 5.94558029 17.0380767"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnly);
export default __webpack_public_path__ + "static/media/logo-only.3348ae20ec1567c5436a89c369f26c10.svg";
export { ForwardRef as ReactComponent };